import { render, staticRenderFns } from "./ObtainingAccessKey.vue?vue&type=template&id=54c01e74&scoped=true"
import script from "./ObtainingAccessKey.vue?vue&type=script&lang=js"
export * from "./ObtainingAccessKey.vue?vue&type=script&lang=js"
import style0 from "./ObtainingAccessKey.vue?vue&type=style&index=0&id=54c01e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c01e74",
  null
  
)

export default component.exports